<template>

        <md-card>
          <!-- <md-card-header class="md-card-header-icon">
            <div class="card-icon">
              <md-icon>design_services</md-icon>
            </div>
            <h4 class="title">
              Service Information
            </h4>
          </md-card-header> -->
          <md-card-content>
            <!-- <div class="md-layout">
              <label class="md-layout-item md-size-15 md-form-label">
                SE No. (Read)
              </label>
              <div class="md-layout-item">
                <validation-provider rules="no" ref="service_estimate_no" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <md-input ref="service_estimate_no_input" readonly v-model="service_estimate.service_estimate_no"/>
                  <validation-error :errors="apiValidationErrors.service_estimate_no" />
                </md-field>sdsa
                <span>{{ errors[0] }}</span>
              </validation-provider>
              </div>
            </div> -->

            <div class="md-layout md-glutter">
              <div class="md-layout-item md-small-size-100">
                <div class="md-layout-item">
                  <validation-provider rules="tanggal" ref="service_estimate_create_at_datetime" v-slot="{ errors }">
                  <md-field class="md-invalid">
                    <label > Create Date (Read)</label>
                    <md-input  ref="service_estimate_create_at_datetime_input" v-model="service_estimate.service_estimate_create_at_datetime" readonly/>
                    <validation-error :errors="apiValidationErrors.service_estimate_create_at_datetime" />
                  </md-field>
                  <span>{{ errors[0] }}</span>
                </validation-provider>
                </div>
              </div>


              <div v-if="user && !user.pool && options_pool_list" class="md-layout-item md-small-size-100">
                <div class="md-layout-item">
                  <validation-provider rules="pool" ref="pool" v-slot="{ errors }">
                  <md-field class="md-invalid">
                    <label >Pool</label>
                    <md-select v-model="service_estimate.service_estimate_pool" @md-selected="onChangePool($event)" :required="!user.pool">
                          <md-option v-for="option in options_pool_list" :key="option.value" :value="option.id">
                            {{ option.pool_name }}
                          </md-option>
                    </md-select>
                    <validation-error :errors="apiValidationErrors.service_estimate_pool" />
                  <span class="md-error">{{ errors[0] }}</span>
                  </md-field>
                  </validation-provider>
                </div>
              </div>

            </div>

            <div class="md-layout">
              
              

              <div class="md-layout-item md-small-size-100">
                <div class="md-layout-item">
                  <validation-provider rules="sa" ref="service_estimate_service_advisor" v-slot="{ errors }">
                  <md-field class="md-invalid">
                    <label >Service Advisor</label>
                    <md-select v-model="service_estimate.service_estimate_service_advisor" required>
                          <md-option v-for="option in options_sa_list" :key="option.value" :value="option.id">
                            {{ option.name }}
                          </md-option>
                    </md-select>
                    <validation-error :errors="apiValidationErrors.service_estimate_service_advisor" />
                  <span class="md-error">{{ errors[0] }}</span>
                  </md-field>
                  </validation-provider>
                </div>
              </div>

              <div class="md-layout-item md-small-size-100">
                
                <div class="md-layout-item">
                  <validation-provider rules="type" ref="service_estimate_type" v-slot="{ errors }">
                  <md-field class="md-invalid">
                    <label for="">Service Type</label>
                    <md-select v-model="service_estimate.service_estimate_type" required>
                      <md-option value="1">Internal</md-option>
                      <!-- <md-option value="2">External</md-option> -->
                    </md-select>
                    <validation-error :errors="apiValidationErrors.service_estimate_type" />
                    <span class="md-error">{{ errors[0] }}</span>
                  </md-field>
                  </validation-provider>
                </div>
              </div>

              <div v-if="service_estimate.service_estimate_type == 1" class="md-layout-item md-small-size-100">
                
                <div class="md-layout-item">
                  <validation-provider ref="service_estimate_billed" v-slot="{ errors }">
                  <md-field class="md-invalid">
                    <label for="">Billed</label>
                    <md-select v-model="service_estimate.service_estimate_billed" required>
                      <md-option value="1">Company</md-option>
                      <md-option value="2">Driver/Customer</md-option>
                    </md-select>
                    <validation-error :errors="apiValidationErrors.service_estimate_billed" />
                    <span class="md-error">{{ errors[0] }}</span>
                  </md-field>
                  </validation-provider>
                </div>
              </div>

              <div class="md-layout-item md-small-size-100">
                
                <div class="md-layout-item">
                  <validation-provider rules="ppn" ref="service_estimate_ppn" v-slot="{ errors }">
                  <md-field class="md-invalid">
                    <label for="">PPN</label>
                    <md-select v-model="service_estimate.service_estimate_ppn" required>
                      <md-option value="0">Use PPN</md-option>
                      <md-option value="1">Not use PPN</md-option>
                    </md-select>
                    <validation-error :errors="apiValidationErrors.service_estimate_create_at_datetime" />
                    <span class="md-error">{{ errors[0] }}</span>
                  </md-field>
                  </validation-provider>
                </div>
              </div>
              <div class="md-layout-item md-small-size-100">
                
                <div class="md-layout-item">
                  <validation-provider rules="guarantee" ref="service_estimate_guarantee" v-slot="{ errors }">
                  <md-field class="md-invalid">
                  <label>Guarentee</label>
                    <md-select v-model="service_estimate.service_estimate_guarantee" required>
                      <md-option value="0">Not Guarantee</md-option>
                      <md-option value="1">Guarantee</md-option>
                    </md-select>
                    <validation-error :errors="apiValidationErrors.service_estimate_create_at_datetime" />
                    <span class="md-error">{{ errors[0] }}</span>
                  </md-field>
                  </validation-provider>
                </div>
              </div>
            </div>
            
            <!-- <div class="md-layout md-glutter">
              <div class="md-layout-item md-small-size-100">
                
                <div class="md-layout-item">
                  <label for="">PPN</label>
                  <md-field class="md-invalid">
                    <input type="checkbox" v-model="service_estimate.service_estimate_ppn" required>
                    <validation-error :errors="apiValidationErrors.service_estimate_create_at_datetime" />
                  </md-field>
                </div>
              </div>
              <div class="md-layout-item md-small-size-100">
                
                <div class="md-layout-item">
                  <label>Guarentee</label>
                  <md-field class="md-invalid">
                    <input type="checkbox" v-model="service_estimate.service_estimate_guarantee" required>
                    <validation-error :errors="apiValidationErrors.service_estimate_create_at_datetime" />
                  </md-field>
                </div>
              </div>
            </div> -->
            <br>

            <md-card>
                <div class="md-layout">
                  <div class="md-layout-item md-small-size-100">
                    <!-- <autoextra :collection="keluhan" v-slot="{item,last,index}">
                      
                      <div  :class="{last: last}">

                      <div v-if="item.keluhan || item.keluhan == 0 || last" class="columns">
                        <label :id="'labelKeluhanFlag_'+index" class="label">{{last ? 'New ' : ''}}Keluhan {{!last ? index + 1 : ''}}</label>
                        <div class="md-layout md-gutter">
                          
                          <div class="md-layout-item md-small-size-100">
                            <input v-model="item.id" :readonly="true" type="hidden"/>

                            <md-field > -->
                              <!-- <label class="label" >Keluhan</label> -->
                              <!-- <md-input  v-model="item.keluhan" @change="onChangeKeluhan(index, item.keluhan)"/>
                              <validation-error :errors="apiValidationErrors.keluhan" />
                                <span :id="'flagKeluhan'" style="display:none; color:red;">Field is required</span>
                              
                            </md-field>
                             <span id="flagKeluhanType" style="display:none; color:red;">Field is required</span> -->
                                <!-- <span :id="'flagKeluhan'+index" style="display:none; color:red;">Field is required</span> -->
                          <!-- </div>
                          <md-card-actions style="border:none;" >
                            <md-button class="md-danger md-dense" @click="deleteColumn(index)" v-if="item.keluhan">
                              delete
                            </md-button>
                          </md-card-actions>
                        </div>
                      </div>
                      </div>
                    </autoextra> -->
                    <autoextra :collection="keluhan" v-slot="{item,last,index}">
                        <div  :class="{last: last}">
                          <div v-if="item.keluhan||last" class="columns">
                            <label :id="'labelKeluhanFlag_'+index" style="font-weight:bold;" class="label">{{last ? 'New ' : ''}}Keluhan {{!last ? index + 1 : ''}}</label>
                             <span id="flagKeluhanType" style="display:none; color:red;">Field is required</span>
                            <div class="md-layout md-gutter">

                              <div class="md-layout-item" style="margin-bottom:10px;">
                              <input v-model="item.id" :readonly="true" type="hidden"/>

                              

                              <div class="md-layout-item md-small-size-100" style="margin-bottom:10px;">
                                <md-field >
                                  <label class="label" >Keluhan detail</label>
                                  <md-input  v-model="item.keluhan" @change="onChangeKeluhan(index, item.keluhan)"/>
                                </md-field>
                                <span :id="'flagKeluhan_'+index" style="display:none; color:red;">Field is required</span>
                              </div>

                              
                            
                              

                              
                            
                              <md-card-actions style="border:none;">
                              <md-button class="md-danger md-dense"  @click="deleteColumn(index)" v-if="item.keluhan">
                                delete
                              </md-button>
                              </md-card-actions>
                            </div>            
                          </div>
                        </div>
                        </div>
                        </autoextra>
                  </div>
                </div>
            </md-card>
          </md-card-content>
        </md-card>  
</template>
<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
  import {extend} from 'vee-validate';
  import { required } from 'vee-validate/dist/rules';
import  Autoextra  from 'vue-autoextra';

extend('no', {
  ...required,
  message: 'No is required'
  });
  extend('tanggal', {
  ...required,
  message: 'tanggal is required'
  });
  extend('sa', {
  ...required,
  message: 'SA is required'
  });
  extend('ppn', {
  ...required,
  message: 'PPN is required'
  });
  extend('type', {
  ...required,
  message: 'Type is required'
  });
  extend('pool', {
  ...required,
  message: 'Pool is required'
  });
  extend('guarantee', {
  ...required,
  message: 'Guarantee is required'
  });
  extend('keluhan', {
  ...required,
  message: 'Keluhan is required'
  });
export default {
  name: "service-card",

  props: {
    service_estimate: null,
  },

  components: { ValidationError,Autoextra },

  mixins: [formMixin],
 watch: {
      service_estimate(currentValue) {
        console.log(currentValue)
      }
 },
  data() {
    return {
      options_sa_list : null,
      options_pool_list: null,
      keluhan: [],
      user: null,
      firstTime: true,
    };
  },
  
  created() {
          this.onOpen()
  },
  
  methods:{
    //fungsi saat pertamakali page di buka
    async onOpen(){
     // console.log(this.service_estimate);
     //set value service_estimate_type
     this.service_estimate.service_estimate_type = 1
      //set value date time
      this.service_estimate.service_estimate_create_at_datetime= this.$moment(new Date()).format('YYYY-MM-DD')
      //ambil list user dengan role sa 
      // await this.$store.dispatch("users/list_sa")
      this.user = await this.$store.getters["profile/me"];
      if(this.user.pool){
        var query = {"filter":{role:'service_advisor',pool:this.user.pool.id}}
        this.service_estimate.service_estimate_pool = this.user.pool.id;
        if(!this.user.pool.warehouse_workshop){
          this.alertWarehouseNotfound()
          return
        }
        this.service_estimate.warehouse_workshop = this.user.pool.warehouse_workshop.id;
        await this.$store.dispatch("users/list",query);
        this.options_sa_list = await this.$store.getters["users/list"]
      }
      else{
        await this.$store.dispatch("workshop_pool/list");
        this.options_pool_list = await this.$store.getters["workshop_pool/list"]
        console.log(this.options_pool_list)
      }
      
      
    },

      //ambil data dari parent, digunakan saat edit
      async getDataParent() { 
        //console.log(this.service_estimate.service_estimate_keluhan);
        //this.keluhan = this.service_estimate.service_estimate_keluhan
        //loop nilai keluhan untuk membuat autoextra row
        this.service_estimate.service_estimate_keluhan.forEach((value, index) => {
          this.$set(this.keluhan, index, {
                  id : value.id,
                  keluhan : value.keluhan
                });
          });
      },

      // onChangeKeluhan(index,data){
      //   let error = document.getElementById("flagKeluhan"+index);
      //   let errorType = document.getElementById("flagKeluhanType");
      //   error.style.display = "none"
      //   errorType.style.display = "none"

      //   if(data!=null && data!=""){
      //   error.style.display = "none"
      //   }
      //   else{
      //     error.style.display = "block"
      //   }

      // },

      // onChangeKeluhan(index,data){

      //     if(Object.keys(this.keluhan).length == 0){
      //       document.getElementById("flagKeluhanType").style.display = "block"
      //     }
      //     else{
      //       document.getElementById("flagKeluhanType").style.display = "none"
      //     }


      //   let error = document.getElementById("flagKeluhan_"+index);
      //   if(data!=null && data!=""){
      //   error.style.display = "none"
      //   }
      //   else{
      //     error.style.display = "block"
      //   }

      // },
      async onChangePool(id){
        
        if(!this.firstTime){
          console.log("hapus sa");
          this.options_sa_list = null
          this.service_estimate.service_estimate_service_advisor = null
        }
        
        
        if(this.options_pool_list){
          var indexOptionList = this.options_pool_list.findIndex(p => p.id ==  this.service_estimate.service_estimate_pool)
          
          if(!this.options_pool_list[indexOptionList].pool_workshop_warehouse){
              this.alertWarehouseNotfound(this.options_pool_list[indexOptionList].pool_name)
              return
          }       
            
            this.service_estimate.warehouse_workshop = this.options_pool_list[indexOptionList].pool_workshop_warehouse.id;
        }
        

          var query = {"filter":{role:'service_advisor',pool:id}}
          await this.$store.dispatch("users/list",query);
          this.options_sa_list = await this.$store.getters["users/list"]
          this.firstTime = false;
        
      },

      async alertWarehouseNotfound(pool_name){
        await this.$store.dispatch(
          "alerts/error",
          "Warehouse workshop for the selected pool "+pool_name+" not found"
        );
        
        // this.service_estimate.service_estimate_pool = null
      },


      onChangeKeluhan(){
      let error = document.getElementById("flagKeluhanType");
        error.style.display = "none"
      flagKeluhanType
      var filter = this.keluhan.filter(function(el) {
           console.log(el);
            return el != null;
          });
          console.log(filter)
          var int= 0
          for (const [key, value] of Object.entries(filter)) {
                        console.log(key);
                        console.log(value);
                        if(!value.keluhan){
                          int++
                        }
                        else{
                          console.log(key-int);
                          this.$set(this.keluhan, key-int, {
                             id : value.id,
                            keluhan : value.keluhan,
                            
                          });
                          if(int!=0){
                            this.$set(this.keluhan, key, {
                               id :null,
                              keluhan : null,
                            });
                          }
                          
                          int= 0
                        }
                        

                      }
      
    },



    //fungsi yang di panggil dari sisi parent untuk mengechek validasi form di child ini
   async validateForm() {
      // const service_estimate_no = this.$refs['service_estimate_no'];
      const service_estimate_create_at_datetime = this.$refs['service_estimate_create_at_datetime'];
      const service_estimate_service_advisor = this.$refs['service_estimate_service_advisor'];
      const service_estimate_ppn = this.$refs['service_estimate_ppn'];
      const service_estimate_type = this.$refs['service_estimate_type'];
      const service_estimate_billed = this.$refs['service_estimate_billed'];
      const service_estimate_guarantee = this.$refs['service_estimate_guarantee'];
      
      // const keluhan = this.$refs['keluhan'];
    let result = []
      // result.push(
      //     await service_estimate_no.validate().then(function(data){
      //     return data.valid
      //     })
      // ) 
      result.push(
        await service_estimate_create_at_datetime.validate().then(function(data){
          return data.valid
        })
      )
      
      // result.push(
      //   await keluhan.validate().then(function(data){
      //     return data.valid
      //   })
      // )

      result.push(
        await service_estimate_service_advisor.validate().then(function(data){
          return data.valid
        })
      )
      result.push(
        await service_estimate_type.validate().then(function(data){
          return data.valid
        })
      )
      
      if(this.service_estimate.service_estimate_type == 1){
        result.push(
          await service_estimate_billed.validate().then(function(data){
            return data.valid
          })
        )
      }
      result.push(
        await service_estimate_ppn.validate().then(function(data){
          return data.valid
        })
      )
      result.push(
        await service_estimate_guarantee.validate().then(function(data){
          return data.valid
        })
      )
      // if(Object.keys(this.keluhan).length == 0){

      //       console.log("asdad");
      //   for (const [key, value] of Object.entries(this.keluhan)) {
      //     if(!value.keluhan){
      //       document.getElementById("flagKeluhan"+key).style.display = "block"
      //       document.getElementById("labelKeluhanFlag_"+key).scrollIntoView({behavior: 'auto'});
      //       result.push(false)
      //     }
      //   }
      // }

      if(Object.keys(this.keluhan).length != 0){
      
        // for (const [key, value] of Object.entries(this.keluhan)) {
        //   console.log("value");
        //   console.log(value);
        //   if(!value.keluhan){
            
        //   console.log("rrrr");
        //       document.getElementById("flagKeluhan_"+key).style.display = "block"
        //     result.push(false)
        //   }
        // }
        if(!this.keluhan[0].keluhan){
          document.getElementById("flagKeluhanType").style.display = "block"
         result.push(false)
        }
      }

      if(Object.keys(this.keluhan).length == 0){
            document.getElementById("flagKeluhanType").style.display = "block"
            // document.getElementById("labelKeluhanFlag_").scrollIntoView({behavior: 'auto'});
            result.push(false)
      }
      
      return result.every(Boolean)
    },
    
    // focusNoEstimate(){
    //     // this.$refs.service_estimate_no_input.$el.focus();
    //     this.$refs.service_estimate_create_at_datetime_input.$el.focus();
      
    // },
    //fungsi untuk menghapus colum keluhan
    deleteColumn(index){
        if (index > -1) {
           this.keluhan.splice(index, 1)
        }
        console.log(this.keluhan);
        
      },
      
      getData() {
            //this.$emit('data', this.keluhan)
           this.service_estimate.keluhan = this.keluhan
        },
  },
};

</script>

<style scoped>
.md-layout-item{
  margin-top:10px;
}

.md-card{
  box-shadow: 0 6px 10px 2px rgb(0 0 0 / 10%), 0 6px 10px 5px rgb(0 0 0 / 7%);
}
</style>
